import * as types from 'modules/campaignFiles/actionTypes';
import { PATCH_CONVERSATION_STATUS_SUCCESS } from 'modules/chat/actionTypes';
import * as actionTypes from 'modules/interventions/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import("../types").CampaignFile>} CampaignFilesDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import('../types').CampaignFile>} */
const campaignFilesAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const updateOne = (state, { payload }) => campaignFilesAdapter.updateOne(state, payload);

/**
 * @param {CampaignFilesDataEntity} state
 * @param {import("modules/global/generic.types").Action<import('modules/global/generic.types').PageContent<import('../types').CampaignFile>>} action
 * @returns {CampaignFilesDataEntity}
 */
const updateAllFromPage = (state, { payload: { content } }) => campaignFilesAdapter.updateMany(state, content);

const setOneFromIntervention = (state, { payload: { campaignFileId, campaignFiles } }) =>
  campaignFilesAdapter.updateOne(state, { id: campaignFileId, ...campaignFiles });

/**
 * @param {CampaignFilesDataEntity} state
 * @param {import('modules/chat/types').PatchConversationStatusSuccessAction} action
 * @returns {CampaignFilesDataEntity}
 */
const updateFromReadMessages = (state, { meta: { campaignFileId } = {} }) => {
  if (campaignFileId) {
    return campaignFilesAdapter.updateOne(state, {
      payload: {
        ...state.entities[campaignFileId],
        unreadMessagesCount: 0,
        conversationContext: { ...state.entities[campaignFileId].conversationContext, unreadCount: 0 },
      },
    });
  }
  return state;
};

export default createReducer(campaignFilesAdapter.getInitialState(), {
  [types.APPROVE_MANUALLY_SUCCESS]: updateOne,
  [types.CREATE_CHECKLISTS_SUCCESS]: updateOne,
  [types.PATCH_CAMPAIGN_FILE_SUCCESS]: updateOne,
  [types.FETCH_FILTERED_CAMPAIGN_FILES_SUCCESS]: updateAllFromPage,
  [types.FETCH_CAMPAIGN_FILES_SUCCESS]: updateAllFromPage,
  [types.FETCH_CAMPAIGN_FILE_SUCCESS]: updateOne,
  [actionTypes.FETCH_INTERVENTION_SUCCESS]: setOneFromIntervention,
  [PATCH_CONVERSATION_STATUS_SUCCESS]: updateFromReadMessages,
});
